// @TODO: Remove condition for Ukrainian language after deal with wrong language code in properties import
export function getDefaultLanguage(lang: string | undefined): string {
  return !lang ? 'en' : lang === 'ua' ? 'uk' : lang;
}
